//EMPLOYEES_LIST
export const EMPLOYEES_LIST_REQUEST = "EMPLOYEES_LIST_REQUEST";
export const EMPLOYEES_LIST_SUCCESS = "EMPLOYEES_LIST_SUCCESS";
export const EMPLOYEES_LIST_FAIL = "EMPLOYEES_LIST_FAIL";

//EMPLOYEES_LIST
export const ADMIN_UPDATE_BULK_EMPLOYEE_REQUEST =
  "ADMIN_UPDATE_BULK_EMPLOYEE_REQUEST";
export const ADMIN_UPDATE_BULK_EMPLOYEE_SUCCESS =
  "ADMIN_UPDATE_BULK_EMPLOYEE_SUCCESS";
export const ADMIN_UPDATE_BULK_EMPLOYEE_FAIL =
  "ADMIN_UPDATE_BULK_EMPLOYEE_FAIL";

//EDIT_EMPLOYEE
export const EDIT_EMPLOYEE_REQUEST = "EDIT_EMPLOYEE_REQUEST";
export const EDIT_EMPLOYEE_SUCCESS = "EDIT_EMPLOYEE_SUCCESS";
export const EDIT_EMPLOYEE_FAIL = "EDIT_EMPLOYEE_FAIL";

//EMPLOYEES_LIST_USER_ID
export const EMPLOYEES_USER_ID_LIST_REQUEST = "EMPLOYEES_USER_ID_LIST_REQUEST";
export const EMPLOYEES_USER_ID_LIST_SUCCESS = "EMPLOYEES_USER_ID_LIST_SUCCESS";
export const EMPLOYEES_USER_ID_LIST_FAIL = "EMPLOYEES_USER_ID_LIST_FAIL";

//EMPLOYEE_CHECKIN_RANGE_REPORT
export const EMPLOYEE_CHECKIN_RANGE_REPORT_REQUEST =
  "EMPLOYEE_CHECKIN_RANGE_REPORT_REQUEST";
export const EMPLOYEE_CHECKIN_RANGE_REPORT_SUCCESS =
  "EMPLOYEE_CHECKIN_RANGE_REPORT_SUCCESS";
export const EMPLOYEE_CHECKIN_RANGE_REPORT_FAIL =
  "EMPLOYEE_CHECKIN_RANGE_REPORT_FAIL";

//EMPLOYEE_LATE_COMING_RANGE_REPORT
export const EMPLOYEE_LATE_COMING_RANGE_REPORT_REQUEST =
  "EMPLOYEE_LATE_COMING_RANGE_REPORT_REQUEST";
export const EMPLOYEE_LATE_COMING_RANGE_REPORT_SUCCESS =
  "EMPLOYEE_LATE_COMING_RANGE_REPORT_SUCCESS";
export const EMPLOYEE_LATE_COMING_RANGE_REPORT_FAIL =
  "EMPLOYEE_LATE_COMING_RANGE_REPORT_FAIL";

//EMPLOYEES_ALL_SCREENSHOT
export const EMPLOYEES_ALL_SCREENSHOT_REQUEST =
  "EMPLOYEES_ALL_SCREENSHOT_REQUEST";
export const EMPLOYEES_ALL_SCREENSHOT_SUCCESS =
  "EMPLOYEES_ALL_SCREENSHOT_SUCCESS";
export const EMPLOYEES_ALL_SCREENSHOT_FAIL = "EMPLOYEES_ALL_SCREENSHOT_FAIL";

//EMPLOYEES_ALL_CHECKIN
export const EMPLOYEES_ALL_CHECKIN_REQUEST = "EMPLOYEES_ALL_CHECKIN_REQUEST";
export const EMPLOYEES_ALL_CHECKIN_SUCCESS = "EMPLOYEES_ALL_CHECKIN_SUCCESS";
export const EMPLOYEES_ALL_CHECKIN_FAIL = "EMPLOYEES_ALL_CHECKIN_FAIL";

//EMPLOYEES_ALL_ACTIVITY
export const EMPLOYEES_ALL_ACTIVITY_REQUEST = "EMPLOYEES_ALL_ACTIVITY_REQUEST";
export const EMPLOYEES_ALL_ACTIVITY_SUCCESS = "EMPLOYEES_ALL_ACTIVITY_SUCCESS";
export const EMPLOYEES_ALL_ACTIVITY_FAIL = "EMPLOYEES_ALL_ACTIVITY_FAIL";

//EMPLOYEES_ALL_TIMESHEET
export const EMPLOYEES_ALL_TIMESHEET_REQUEST =
  "EMPLOYEES_ALL_TIMESHEET_REQUEST";
export const EMPLOYEES_ALL_TIMESHEET_SUCCESS =
  "EMPLOYEES_ALL_TIMESHEET_SUCCESS";
export const EMPLOYEES_ALL_TIMESHEET_FAIL = "EMPLOYEES_ALL_TIMESHEET_FAIL";

//EMPLOYEES_ALL_TIMESHEET_FOR_HRM
export const EMPLOYEES_ALL_TIMESHEET_FOR_HRM_REQUEST =
  "EMPLOYEES_ALL_TIMESHEET_FOR_HRM_REQUEST";
export const EMPLOYEES_ALL_TIMESHEET_FOR_HRM_SUCCESS =
  "EMPLOYEES_ALL_TIMESHEET_FOR_HRM_SUCCESS";
export const EMPLOYEES_ALL_TIMESHEET_FOR_HRM_FAIL =
  "EMPLOYEES_ALL_TIMESHEET_FOR_HRM_FAIL";

//EMPLOYEES_ALL_NEW_TIMESHEET
export const EMPLOYEES_ALL_NEW_TIMESHEET_REQUEST =
  "EMPLOYEES_ALL_NEW_TIMESHEET_REQUEST";
export const EMPLOYEES_ALL_NEW_TIMESHEET_SUCCESS =
  "EMPLOYEES_ALL_NEW_TIMESHEET_SUCCESS";
export const EMPLOYEES_ALL_NEW_TIMESHEET_FAIL =
  "EMPLOYEES_ALL_NEW_TIMESHEET_FAIL";
//EMPLOYEES_ALL_NEW_TIMESHEET_STATS
export const EMPLOYEES_ALL_NEW_TIMESHEET_STATS_REQUEST =
  "EMPLOYEES_ALL_NEW_TIMESHEET_STATS_REQUEST";
export const EMPLOYEES_ALL_NEW_TIMESHEET_STATS_SUCCESS =
  "EMPLOYEES_ALL_NEW_TIMESHEET_STATS_SUCCESS";
export const EMPLOYEES_ALL_NEW_TIMESHEET_STATS_FAIL =
  "EMPLOYEES_ALL_NEW_TIMESHEET_STATS_FAIL";

//EMPLOYEE_SINGLE_NEW_TIMESHEET
export const EMPLOYEE_SINGLE_NEW_TIMESHEET_REQUEST =
  "EMPLOYEE_SINGLE_NEW_TIMESHEET_REQUEST";
export const EMPLOYEE_SINGLE_NEW_TIMESHEET_SUCCESS =
  "EMPLOYEE_SINGLE_NEW_TIMESHEET_SUCCESS";
export const EMPLOYEE_SINGLE_NEW_TIMESHEET_FAIL =
  "EMPLOYEE_SINGLE_NEW_TIMESHEET_FAIL";
//EMPLOYEE_SINGLE_NEW_TIMESHEET_STATS
export const EMPLOYEE_SINGLE_NEW_TIMESHEET_STATS_REQUEST =
  "EMPLOYEE_SINGLE_NEW_TIMESHEET_STATS_REQUEST";
export const EMPLOYEE_SINGLE_NEW_TIMESHEET_STATS_SUCCESS =
  "EMPLOYEE_SINGLE_NEW_TIMESHEET_STATS_SUCCESS";
export const EMPLOYEE_SINGLE_NEW_TIMESHEET_STATS_FAIL =
  "EMPLOYEE_SINGLE_NEW_TIMESHEET_STATS_FAIL";

//EMPLOYEES_OVERTIME
export const EMPLOYEES_OVERTIME_REQUEST = "EMPLOYEES_OVERTIME_REQUEST";
export const EMPLOYEES_OVERTIME_SUCCESS = "EMPLOYEES_OVERTIME_SUCCESS";
export const EMPLOYEES_OVERTIME_FAIL = "EMPLOYEES_OVERTIME_FAIL";

//CHANGE_STATUS_OF_TIMESHEET_IN_RANGE
export const CHANGE_STATUS_OF_TIMESHEET_IN_RANGE_REQUEST =
  "CHANGE_STATUS_OF_TIMESHEET_IN_RANGE_REQUEST";
export const CHANGE_STATUS_OF_TIMESHEET_IN_RANGE_SUCCESS =
  "CHANGE_STATUS_OF_TIMESHEET_IN_RANGE_SUCCESS";
export const CHANGE_STATUS_OF_TIMESHEET_IN_RANGE_FAIL =
  "CHANGE_STATUS_OF_TIMESHEET_IN_RANGE_FAIL";

//CHANGE_STATUS__MANY_EMPLOYEES_OF_TIMESHEET_IN_RANGE
export const CHANGE_STATUS_OF_MANY_EMPLOYEES_TIMESHEET_IN_RANGE_REQUEST =
  "CHANGE_STATUS_OF_MANY_EMPLOYEES_TIMESHEET_IN_RANGE_REQUEST";
export const CHANGE_STATUS_OF_MANY_EMPLOYEES_TIMESHEET_IN_RANGE_SUCCESS =
  "CHANGE_STATUS_OF_MANY_EMPLOYEES_TIMESHEET_IN_RANGE_SUCCESS";
export const CHANGE_STATUS_OF_MANY_EMPLOYEES_TIMESHEET_IN_RANGE_FAIL =
  "CHANGE_STATUS_OF_MANY_EMPLOYEES_TIMESHEET_IN_RANGE_FAIL";

//CHANGE_STATUS_OF_TIMESHEET_IN_SINGLE
export const CHANGE_STATUS_OF_TIMESHEET_IN_SINGLE_REQUEST =
  "CHANGE_STATUS_OF_TIMESHEET_IN_SINGLE_REQUEST";
export const CHANGE_STATUS_OF_TIMESHEET_IN_SINGLE_SUCCESS =
  "CHANGE_STATUS_OF_TIMESHEET_IN_SINGLE_SUCCESS";
export const CHANGE_STATUS_OF_TIMESHEET_IN_SINGLE_FAIL =
  "CHANGE_STATUS_OF_TIMESHEET_IN_SINGLE_FAIL";

//ADD_ONE_EMPLOYEE_IN_PROJECT
export const ADD_ONE_EMPLOYEE_IN_PROJECT_REQUEST =
  "ADD_ONE_EMPLOYEE_IN_PROJECT_REQUEST";
export const ADD_ONE_EMPLOYEE_IN_PROJECT_SUCCESS =
  "ADD_ONE_EMPLOYEE_IN_PROJECT_SUCCESS";
export const ADD_ONE_EMPLOYEE_IN_PROJECT_FAIL =
  "ADD_ONE_EMPLOYEE_IN_PROJECT_FAIL";

//ADD_ONE_EMPLOYEE_IN_PROJECT_ID
export const ADD_ONE_EMPLOYEE_IN_PROJECT_ID_REQUEST =
  "ADD_ONE_EMPLOYEE_IN_PROJECT_ID_REQUEST";
export const ADD_ONE_EMPLOYEE_IN_PROJECT_ID_SUCCESS =
  "ADD_ONE_EMPLOYEE_IN_PROJECT_ID_SUCCESS";
export const ADD_ONE_EMPLOYEE_IN_PROJECT_ID_FAIL =
  "ADD_ONE_EMPLOYEE_IN_PROJECT_ID_FAIL";

//EMPLOYEE_TIMEPRO_DATE
export const EMPLOYEE_TIMEPRO_DATE_REQUEST = "EMPLOYEE_TIMEPRO_DATE_REQUEST";
export const EMPLOYEE_TIMEPRO_DATE_SUCCESS = "EMPLOYEE_TIMEPRO_DATE_SUCCESS";
export const EMPLOYEE_TIMEPRO_DATE_FAIL = "EMPLOYEE_TIMEPRO_DATE_FAIL";

//EMPLOYEE_TIMEPRO_WEEK
export const EMPLOYEE_TIMEPRO_WEEK_REQUEST = "EMPLOYEE_TIMEPRO_WEEK_REQUEST";
export const EMPLOYEE_TIMEPRO_WEEK_SUCCESS = "EMPLOYEE_TIMEPRO_WEEK_SUCCESS";
export const EMPLOYEE_TIMEPRO_WEEK_FAIL = "EMPLOYEE_TIMEPRO_WEEK_FAIL";

//EMPLOYEE_TIMEPRO_SEVEN
export const EMPLOYEE_TIMEPRO_SEVEN_REQUEST = "EMPLOYEE_TIMEPRO_SEVEN_REQUEST";
export const EMPLOYEE_TIMEPRO_SEVEN_SUCCESS = "EMPLOYEE_TIMEPRO_SEVEN_SUCCESS";
export const EMPLOYEE_TIMEPRO_SEVEN_FAIL = "EMPLOYEE_TIMEPRO_SEVEN_FAIL";

//EMPLOYEES_ALL_TEAMS
export const EMPLOYEES_ALL_TEAMS_REQUEST = "EMPLOYEES_ALL_TEAMS_REQUEST";
export const EMPLOYEES_ALL_TEAMS_SUCCESS = "EMPLOYEES_ALL_TEAMS_SUCCESS";
export const EMPLOYEES_ALL_TEAMS_FAIL = "EMPLOYEES_ALL_TEAMS_FAIL";

//EMPLOYEES_ADD_TIME_IN_PROJECT
export const EMPLOYEES_ADD_TIME_IN_PROJECT_REQUEST =
  "EMPLOYEES_ADD_TIME_IN_PROJECT_REQUEST";
export const EMPLOYEES_ADD_TIME_IN_PROJECT_SUCCESS =
  "EMPLOYEES_ADD_TIME_IN_PROJECT_SUCCESS";
export const EMPLOYEES_ADD_TIME_IN_PROJECT_FAIL =
  "EMPLOYEES_ADD_TIME_IN_PROJECT_FAIL";

//EMPLOYEES_EDIT_TIME_IN_PROJECT
export const EMPLOYEES_EDIT_TIME_IN_PROJECT_REQUEST =
  "EMPLOYEES_EDIT_TIME_IN_PROJECT_REQUEST";
export const EMPLOYEES_EDIT_TIME_IN_PROJECT_SUCCESS =
  "EMPLOYEES_EDIT_TIME_IN_PROJECT_SUCCESS";
export const EMPLOYEES_EDIT_TIME_IN_PROJECT_FAIL =
  "EMPLOYEES_EDIT_TIME_IN_PROJECT_FAIL";

//EMPLOYEES_ALL_REPORT
export const EMPLOYEES_ALL_REPORT_REQUEST = "EMPLOYEES_ALL_REPORT_REQUEST";
export const EMPLOYEES_ALL_REPORT_SUCCESS = "EMPLOYEES_ALL_REPORT_SUCCESS";
export const EMPLOYEES_ALL_REPORT_FAIL = "EMPLOYEES_ALL_REPORT_FAIL";

//EMPLOYEES_ALL
export const EMPLOYEES_ALL_REQUEST = "EMPLOYEES_ALL_REQUEST";
export const EMPLOYEES_ALL_SUCCESS = "EMPLOYEES_ALL_SUCCESS";
export const EMPLOYEES_ALL_FAIL = "EMPLOYEES_ALL_FAIL";

//EMPLOYEES_LIST_USER_ID
export const EMPLOYEES_INVITE_BY_EMAIL_REQUEST =
  "EMPLOYEES_INVITE_BY_EMAIL_REQUEST";
export const EMPLOYEES_INVITE_BY_EMAIL_SUCCESS =
  "EMPLOYEES_INVITE_BY_EMAIL_SUCCESS";
export const EMPLOYEES_INVITE_BY_EMAIL_FAIL = "EMPLOYEES_INVITE_BY_EMAIL_FAIL";

//EMPLOYEES_BLOCK_FROM COMPANY
export const EMPLOYEES_BLOCK_FROM_COMPANY_REQUEST =
  "EMPLOYEES_BLOCK_FROM_COMPANY_REQUEST";
export const EMPLOYEES_BLOCK_FROM_COMPANY_SUCCESS =
  "EMPLOYEES_BLOCK_FROM_COMPANY_SUCCESS";
export const EMPLOYEES_BLOCK_FROM_COMPANY_FAIL =
  "EMPLOYEES_BLOCK_FROM_COMPANY_FAIL";

//EMPLOYEES_DELETE_FROM_COMPANY
export const EMPLOYEES_DELETE_FROM_COMPANY_REQUEST =
  "EMPLOYEES_DELETE_FROM_COMPANY_REQUEST";
export const EMPLOYEES_DELETE_FROM_COMPANY_SUCCESS =
  "EMPLOYEES_DELETE_FROM_COMPANY_SUCCESS";
export const EMPLOYEES_DELETE_FROM_COMPANY_FAIL =
  "EMPLOYEES_DELETE_FROM_COMPANY_FAIL";

//EMPLOYEES_BLOCK_FROM_DEPARTMENT
export const EMPLOYEES_BLOCK_FROM_DEPARTMENT_REQUEST =
  "EMPLOYEES_BLOCK_FROM_DEPARTMENT_REQUEST";
export const EMPLOYEES_BLOCK_FROM_DEPARTMENT_SUCCESS =
  "EMPLOYEES_BLOCK_FROM_DEPARTMENT_SUCCESS";
export const EMPLOYEES_BLOCK_FROM_DEPARTMENT_FAIL =
  "EMPLOYEES_BLOCK_FROM_DEPARTMENT_FAIL";

//UPDATE_EMPLOYEE_DETAILS
export const UPDATE_EMPLOYEE_DETAILS_REQUEST =
  "UPDATE_EMPLOYEE_DETAILS_REQUEST";
export const UPDATE_EMPLOYEE_DETAILS_SUCCESS =
  "UPDATE_EMPLOYEE_DETAILS_SUCCESS";
export const UPDATE_EMPLOYEE_DETAILS_FAIL = "UPDATE_EMPLOYEE_DETAILS_FAIL";

//UPDATE_EMPLOYEE_TYPE
export const UPDATE_EMPLOYEE_TYPE_REQUEST = "UPDATE_EMPLOYEE_TYPE_REQUEST";
export const UPDATE_EMPLOYEE_TYPE_SUCCESS = "UPDATE_EMPLOYEE_TYPE_SUCCESS";
export const UPDATE_EMPLOYEE_TYPE_FAIL = "UPDATE_EMPLOYEE_TYPE_FAIL";

//DELETE_PROJECT_TIME_OF_EMPLOYEE
export const DELETE_PROJECT_TIME_OF_EMPLOYEE_REQUEST =
  "DELETE_PROJECT_TIME_OF_EMPLOYEE_REQUEST";
export const DELETE_PROJECT_TIME_OF_EMPLOYEE_SUCCESS =
  "DELETE_PROJECT_TIME_OF_EMPLOYEE_SUCCESS";
export const DELETE_PROJECT_TIME_OF_EMPLOYEE_FAIL =
  "DELETE_PROJECT_TIME_OF_EMPLOYEE_FAIL";

//SEND_OTP_EMAIL_BY_ADMIN_FOR_USER
export const SEND_OTP_EMAIL_BY_ADMIN_REQUEST =
  "SEND_OTP_EMAIL_BY_ADMIN_REQUEST";
export const SEND_OTP_EMAIL_BY_ADMIN_SUCCESS =
  "SEND_OTP_EMAIL_BY_ADMIN_SUCCESS";
export const SEND_OTP_EMAIL_BY_ADMIN_FAIL = "SEND_OTP_EMAIL_BY_ADMIN_FAIL";

//UPDATE_REASON_IN_EMP_SCREENSHOT
export const UPDATE_REASON_IN_EMP_SCREENSHOT_REQUEST =
  "UPDATE_REASON_IN_EMP_SCREENSHOT_REQUEST";
export const UPDATE_REASON_IN_EMP_SCREENSHOT_SUCCESS =
  "UPDATE_REASON_IN_EMP_SCREENSHOT_SUCCESS";
export const UPDATE_REASON_IN_EMP_SCREENSHOT_FAIL =
  "UPDATE_REASON_IN_EMP_SCREENSHOT_FAIL";

//DELETE_SCREENSHOT
export const DELETE_SCREENSHOT_REQUEST = "DELETE_SCREENSHOT_REQUEST";
export const DELETE_SCREENSHOT_SUCCESS = "DELETE_SCREENSHOT_SUCCESS";
export const DELETE_SCREENSHOT_FAIL = "DELETE_SCREENSHOT_FAIL";

//ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT
export const ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_REQUEST =
  "ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_REQUEST";
export const ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_SUCCESS =
  "ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_SUCCESS";
export const ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_FAIL =
  "ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_FAIL";

//EMPLOYEES_CHECKIN_BY_RANGE
export const EMPLOYEES_CHECKIN_BY_RANGE_REQUEST =
  "EMPLOYEES_CHECKIN_BY_RANGE_REQUEST";
export const EMPLOYEES_CHECKIN_BY_RANGE_SUCCESS =
  "EMPLOYEES_CHECKIN_BY_RANGE_SUCCESS";
export const EMPLOYEES_CHECKIN_BY_RANGE_FAIL =
  "EMPLOYEES_CHECKIN_BY_RANGE_FAIL";

//EMPLOYEES_TOTAL_TIME_BY_RANGE
export const EMPLOYEES_TOTAL_TIME_BY_RANGE_REQUEST =
  "EMPLOYEES_TOTAL_TIME_BY_RANGE_REQUEST";
export const EMPLOYEES_TOTAL_TIME_BY_RANGE_SUCCESS =
  "EMPLOYEES_TOTAL_TIME_BY_RANGE_SUCCESS";
export const EMPLOYEES_TOTAL_TIME_BY_RANGE_FAIL =
  "EMPLOYEES_TOTAL_TIME_BY_RANGE_FAIL";

//EMPLOYEES_EXTRA_INFO
export const EMPLOYEES_EXTRA_INFO_REQUEST = "EMPLOYEES_EXTRA_INFO_REQUEST";
export const EMPLOYEES_EXTRA_INFO_SUCCESS = "EMPLOYEES_EXTRA_INFO_SUCCESS";
export const EMPLOYEES_EXTRA_INFO_FAIL = "EMPLOYEES_EXTRA_INFO_FAIL";

//EMPLOYEES_EXTRA_SOCIAL
export const EMPLOYEES_EXTRA_SOCIAL_REQUEST = "EMPLOYEES_EXTRA_SOCIAL_REQUEST";
export const EMPLOYEES_EXTRA_SOCIAL_SUCCESS = "EMPLOYEES_EXTRA_SOCIAL_SUCCESS";
export const EMPLOYEES_EXTRA_SOCIAL_FAIL = "EMPLOYEES_EXTRA_SOCIAL_FAIL";

//EMPLOYEES_EXTRA_WORK
export const EMPLOYEES_EXTRA_WORK_REQUEST = "EMPLOYEES_EXTRA_WORK_REQUEST";
export const EMPLOYEES_EXTRA_WORK_SUCCESS = "EMPLOYEES_EXTRA_WORK_SUCCESS";
export const EMPLOYEES_EXTRA_WORK_FAIL = "EMPLOYEES_EXTRA_WORK_FAIL";

//GET_EMPLOYEES_EXTRA_INFO
export const GET_EMPLOYEES_EXTRA_INFO_REQUEST =
  "GET_EMPLOYEES_EXTRA_INFO_REQUEST";
export const GET_EMPLOYEES_EXTRA_INFO_SUCCESS =
  "GET_EMPLOYEES_EXTRA_INFO_SUCCESS";
export const GET_EMPLOYEES_EXTRA_INFO_FAIL = "GET_EMPLOYEES_EXTRA_INFO_FAIL";

//ADD_EMPLOYEES_PROFILE_IMAGE
export const ADD_EMPLOYEES_PROFILE_IMAGE_REQUEST =
  "ADD_EMPLOYEES_PROFILE_IMAGE_REQUEST";
export const ADD_EMPLOYEES_PROFILE_IMAGE_SUCCESS =
  "ADD_EMPLOYEES_PROFILE_IMAGE_SUCCESS";
export const ADD_EMPLOYEES_PROFILE_IMAGE_FAIL =
  "ADD_EMPLOYEES_PROFILE_IMAGE_FAIL";

//ADD_EMPLOYEES_EXTRA_PERSONAL_INFO
export const ADD_EMPLOYEES_EXTRA_PERSONAL_INFO_REQUEST =
  "ADD_EMPLOYEES_EXTRA_PERSONAL_INFO_REQUEST";
export const ADD_EMPLOYEES_EXTRA_PERSONAL_INFO_SUCCESS =
  "ADD_EMPLOYEES_EXTRA_PERSONAL_INFO_SUCCESS";
export const ADD_EMPLOYEES_EXTRA_PERSONAL_INFO_FAIL =
  "ADD_EMPLOYEES_EXTRA_PERSONAL_INFO_FAIL";

//ADD_EMPLOYEES_ASSET
export const ADD_EMPLOYEES_ASSET_REQUEST = "ADD_EMPLOYEES_ASSET_REQUEST";
export const ADD_EMPLOYEES_ASSET_SUCCESS = "ADD_EMPLOYEES_ASSET_SUCCESS";
export const ADD_EMPLOYEES_ASSET_FAIL = "ADD_EMPLOYEES_ASSET_FAIL";

//UPDATE_EMPLOYEES_ASSET
export const UPDATE_EMPLOYEES_ASSET_REQUEST = "UPDATE_EMPLOYEES_ASSET_REQUEST";
export const UPDATE_EMPLOYEES_ASSET_SUCCESS = "UPDATE_EMPLOYEES_ASSET_SUCCESS";
export const UPDATE_EMPLOYEES_ASSET_FAIL = "UPDATE_EMPLOYEES_ASSET_FAIL";

//UPDATE_EMPLOYEES_ASSET
export const UPDATE_EMPLOYEES_ARCHIVED_ASSET_REQUEST =
  "UPDATE_EMPLOYEES_ARCHIVED_ASSET_REQUEST";
export const UPDATE_EMPLOYEES_ARCHIVED_ASSET_SUCCESS =
  "UPDATE_EMPLOYEES_ARCHIVED_ASSET_SUCCESS";
export const UPDATE_EMPLOYEES_ARCHIVED_ASSET_FAIL =
  "UPDATE_EMPLOYEES_ARCHIVED_ASSET_FAIL";

//UPDATE_EMPLOYEES_FRONT_DOC
export const UPDATE_EMPLOYEES_FRONT_DOC_REQUEST =
  "UPDATE_EMPLOYEES_FRONT_DOC_REQUEST";
export const UPDATE_EMPLOYEES_FRONT_DOC_SUCCESS =
  "UPDATE_EMPLOYEES_FRONT_DOC_SUCCESS";
export const UPDATE_EMPLOYEES_FRONT_DOC_FAIL =
  "UPDATE_EMPLOYEES_FRONT_DOC_FAIL";

//UPDATE_EMPLOYEES_BACK_DOC
export const UPDATE_EMPLOYEES_BACK_DOC_REQUEST =
  "UPDATE_EMPLOYEES_BACK_DOC_REQUEST";
export const UPDATE_EMPLOYEES_BACK_DOC_SUCCESS =
  "UPDATE_EMPLOYEES_BACK_DOC_SUCCESS";
export const UPDATE_EMPLOYEES_BACK_DOC_FAIL = "UPDATE_EMPLOYEES_BACK_DOC_FAIL";

//UPDATE_EMPLOYEES_PASSPORT_DOC
export const UPDATE_EMPLOYEES_PASSPORT_DOC_REQUEST =
  "UPDATE_EMPLOYEES_PASSPORT_DOC_REQUEST";
export const UPDATE_EMPLOYEES_PASSPORT_DOC_SUCCESS =
  "UPDATE_EMPLOYEES_PASSPORT_DOC_SUCCESS";
export const UPDATE_EMPLOYEES_PASSPORT_DOC_FAIL =
  "UPDATE_EMPLOYEES_PASSPORT_DOC_FAIL";

//UPDATE_EMPLOYEES_VISA_DOC
export const UPDATE_EMPLOYEES_VISA_DOC_REQUEST =
  "UPDATE_EMPLOYEES_VISA_DOC_REQUEST";
export const UPDATE_EMPLOYEES_VISA_DOC_SUCCESS =
  "UPDATE_EMPLOYEES_VISA_DOC_SUCCESS";
export const UPDATE_EMPLOYEES_VISA_DOC_FAIL = "UPDATE_EMPLOYEES_VISA_DOC_FAIL";

//UPDATE_EMPLOYEES_APPLICATION_DOC
export const UPDATE_EMPLOYEES_APPLICATION_DOC_REQUEST =
  "UPDATE_EMPLOYEES_APPLICATION_DOC_REQUEST";
export const UPDATE_EMPLOYEES_APPLICATION_DOC_SUCCESS =
  "UPDATE_EMPLOYEES_APPLICATION_DOC_SUCCESS";
export const UPDATE_EMPLOYEES_APPLICATION_DOC_FAIL =
  "UPDATE_EMPLOYEES_APPLICATION_DOC_FAIL";

//UPDATE_EMPLOYEES_OTHER_DOC
export const UPDATE_EMPLOYEES_OTHER_DOC_REQUEST =
  "UPDATE_EMPLOYEES_OTHER_DOC_REQUEST";
export const UPDATE_EMPLOYEES_OTHER_DOC_SUCCESS =
  "UPDATE_EMPLOYEES_OTHER_DOC_SUCCESS";
export const UPDATE_EMPLOYEES_OTHER_DOC_FAIL =
  "UPDATE_EMPLOYEES_OTHER_DOC_FAIL";

//ARCHIVED_EMPLOYEES_OTHER_DOC
export const ARCHIVED_EMPLOYEES_OTHER_DOC_REQUEST =
  "ARCHIVED_EMPLOYEES_OTHER_DOC_REQUEST";
export const ARCHIVED_EMPLOYEES_OTHER_DOC_SUCCESS =
  "ARCHIVED_EMPLOYEES_OTHER_DOC_SUCCESS";
export const ARCHIVED_EMPLOYEES_OTHER_DOC_FAIL =
  "ARCHIVED_EMPLOYEES_OTHER_DOC_FAIL";

//UPDATE_EMPLOYEES_EMIRATESID_DOC
export const UPDATE_EMPLOYEES_EMIRATESID_DOC_REQUEST =
  "UPDATE_EMPLOYEES_EMIRATESID_DOC_REQUEST";
export const UPDATE_EMPLOYEES_EMIRATESID_DOC_SUCCESS =
  "UPDATE_EMPLOYEES_EMIRATESID_DOC_SUCCESS";
export const UPDATE_EMPLOYEES_EMIRATESID_DOC_FAIL =
  "UPDATE_EMPLOYEES_EMIRATESID_DOC_FAIL";

//UPDATE_EMPLOYEES_Air_REIMBURST_DOC
export const UPDATE_EMPLOYEES_Air_REIMBURST_DOC_REQUEST =
  "UPDATE_EMPLOYEES_Air_REIMBURST_DOC_REQUEST";
export const UPDATE_EMPLOYEES_Air_REIMBURST_DOC_SUCCESS =
  "UPDATE_EMPLOYEES_Air_REIMBURST_DOC_SUCCESS";
export const UPDATE_EMPLOYEES_Air_REIMBURST_DOC_FAIL =
  "UPDATE_EMPLOYEES_Air_REIMBURST_DOC_FAIL";

//UPDATE_EMPLOYEES_EDUCATION_DOC
export const UPDATE_EMPLOYEES_EDUCATION_DOC_REQUEST =
  "UPDATE_EMPLOYEES_EDUCATION_DOC_REQUEST";
export const UPDATE_EMPLOYEES_EDUCATION_DOC_SUCCESS =
  "UPDATE_EMPLOYEES_EDUCATION_DOC_SUCCESS";
export const UPDATE_EMPLOYEES_EDUCATION_DOC_FAIL =
  "UPDATE_EMPLOYEES_EDUCATION_DOC_FAIL";

//UPDATE_EMPLOYEES_LABOUR_DOC
export const UPDATE_EMPLOYEES_LABOUR_DOC_REQUEST =
  "UPDATE_EMPLOYEES_LABOUR_DOC_REQUEST";
export const UPDATE_EMPLOYEES_LABOUR_DOC_SUCCESS =
  "UPDATE_EMPLOYEES_LABOUR_DOC_SUCCESS";
export const UPDATE_EMPLOYEES_LABOUR_DOC_FAIL =
  "UPDATE_EMPLOYEES_LABOUR_DOC_FAIL";

//UPDATE_EMPLOYEES_INSURANCE_DOC
export const UPDATE_EMPLOYEES_INSURANCE_DOC_REQUEST =
  "UPDATE_EMPLOYEES_INSURANCE_DOC_REQUEST";
export const UPDATE_EMPLOYEES_INSURANCE_DOC_SUCCESS =
  "UPDATE_EMPLOYEES_INSURANCE_DOC_SUCCESS";
export const UPDATE_EMPLOYEES_INSURANCE_DOC_FAIL =
  "UPDATE_EMPLOYEES_INSURANCE_DOC_FAIL";

//UPDATE_EMPLOYEES_PASSPORT_PHOTO
export const UPDATE_EMPLOYEES_PASSPORT_PHOTO_REQUEST =
  "UPDATE_EMPLOYEES_PASSPORT_PHOTO_REQUEST";
export const UPDATE_EMPLOYEES_PASSPORT_PHOTO_SUCCESS =
  "UPDATE_EMPLOYEES_PASSPORT_PHOTO_SUCCESS";
export const UPDATE_EMPLOYEES_PASSPORT_PHOTO_FAIL =
  "UPDATE_EMPLOYEES_PASSPORT_PHOTO_FAIL";

//ADD_EMPLOYEES_EXPENSE
export const ADD_EMPLOYEES_EXPENSE_REQUEST = "ADD_EMPLOYEES_EXPENSE_REQUEST";
export const ADD_EMPLOYEES_EXPENSE_SUCCESS = "ADD_EMPLOYEES_EXPENSE_SUCCESS";
export const ADD_EMPLOYEES_EXPENSE_FAIL = "ADD_EMPLOYEES_EXPENSE_FAIL";

//UPDATE_EMPLOYEES_EXPENSE
export const UPDATE_EMPLOYEES_EXPENSE_REQUEST =
  "UPDATE_EMPLOYEES_EXPENSE_REQUEST";
export const UPDATE_EMPLOYEES_EXPENSE_SUCCESS =
  "UPDATE_EMPLOYEES_EXPENSE_SUCCESS";
export const UPDATE_EMPLOYEES_EXPENSE_FAIL = "UPDATE_EMPLOYEES_EXPENSE_FAIL";

//UPDATE_EMPLOYEES_EXPENSE
export const UPDATE_EMPLOYEES_ARCHIVED_EXPENSE_REQUEST =
  "UPDATE_EMPLOYEES_ARCHIVED_EXPENSE_REQUEST";
export const UPDATE_EMPLOYEES_ARCHIVED_EXPENSE_SUCCESS =
  "UPDATE_EMPLOYEES_ARCHIVED_EXPENSE_SUCCESS";
export const UPDATE_EMPLOYEES_ARCHIVED_EXPENSE_FAIL =
  "UPDATE_EMPLOYEES_ARCHIVED_EXPENSE_FAIL";

//GET_ALL_COMPANY_LIST
export const ADMIN_GET_ALL_COMPANY_LIST_REQUEST =
  "ADMIN_GET_ALL_COMPANY_LIST_REQUEST";
export const ADMIN_GET_ALL_COMPANY_LIST_SUCCESS =
  "ADMIN_GET_ALL_COMPANY_LIST_SUCCESS";
export const ADMIN_GET_ALL_COMPANY_LIST_FAIL =
  "ADMIN_GET_ALL_COMPANY_LIST_FAIL";

//OPEN_ANOTHER_COMPANY_LIST
export const ADMIN_OPEN_ANOTHER_COMPANY_LIST_REQUEST =
  "ADMIN_OPEN_ANOTHER_COMPANY_LIST_REQUEST";
export const ADMIN_OPEN_ANOTHER_COMPANY_LIST_SUCCESS =
  "ADMIN_OPEN_ANOTHER_COMPANY_LIST_SUCCESS";
export const ADMIN_OPEN_ANOTHER_COMPANY_LIST_FAIL =
  "ADMIN_OPEN_ANOTHER_COMPANY_LIST_FAIL";

//ARCHIVE_COMPANY_LIST
export const ADMIN_ARCHIVE_COMPANY_LIST_REQUEST =
  "ADMIN_ARCHIVE_COMPANY_LIST_REQUEST";
export const ADMIN_ARCHIVE_COMPANY_LIST_SUCCESS =
  "ADMIN_ARCHIVE_COMPANY_LIST_SUCCESS";
export const ADMIN_ARCHIVE_COMPANY_LIST_FAIL =
  "ADMIN_ARCHIVE_COMPANY_LIST_FAIL";

//ADD_USER_IMPORT
export const ADMIN_ADD_USER_IMPORT_REQUEST = "ADMIN_ADD_USER_IMPORT_REQUEST";
export const ADMIN_ADD_USER_IMPORT_SUCCESS = "ADMIN_ADD_USER_IMPORT_SUCCESS";
export const ADMIN_ADD_USER_IMPORT_FAIL = "ADMIN_ADD_USER_IMPORT_FAIL";

//DYNAMIC_DOCUMENTS_IMPORT
export const ADMIN_DYNAMIC_DOCUMENTS_IMPORT_REQUEST =
  "ADMIN_DYNAMIC_DOCUMENTS_IMPORT_REQUEST";
export const ADMIN_DYNAMIC_DOCUMENTS_IMPORT_SUCCESS =
  "ADMIN_DYNAMIC_DOCUMENTS_IMPORT_SUCCESS";
export const ADMIN_DYNAMIC_DOCUMENTS_IMPORT_FAIL =
  "ADMIN_DYNAMIC_DOCUMENTS_IMPORT_FAIL";

//ADD_USER_IMPORT_UPLOAD
export const ADMIN_ADD_USER_IMPORT_UPLOAD_REQUEST =
  "ADMIN_ADD_USER_IMPORT_UPLOAD_REQUEST";
export const ADMIN_ADD_USER_IMPORT_UPLOAD_SUCCESS =
  "ADMIN_ADD_USER_IMPORT_UPLOAD_SUCCESS";
export const ADMIN_ADD_USER_IMPORT_UPLOAD_FAIL =
  "ADMIN_ADD_USER_IMPORT_UPLOAD_FAIL";

//CHECK_USER_IMPORT
export const ADMIN_CHECK_USER_IMPORT_REQUEST =
  "ADMIN_CHECK_USER_IMPORT_REQUEST";
export const ADMIN_CHECK_USER_IMPORT_SUCCESS =
  "ADMIN_CHECK_USER_IMPORT_SUCCESS";
export const ADMIN_CHECK_USER_IMPORT_FAIL = "ADMIN_CHECK_USER_IMPORT_FAIL";

//ADD_SHIFT
export const ADD_SHIFT_REQUEST = "ADD_SHIFT_REQUEST";
export const ADD_SHIFT_SUCCESS = "ADD_SHIFT_SUCCESS";
export const ADD_SHIFT_FAIL = "ADD_SHIFT_FAIL";

//ADD_WEEK_TEMPLATE_SHIFT
export const ADD_WEEK_TEMPLATE_SHIFT_REQUEST =
  "ADD_WEEK_TEMPLATE_SHIFT_REQUEST";
export const ADD_WEEK_TEMPLATE_SHIFT_SUCCESS =
  "ADD_WEEK_TEMPLATE_SHIFT_SUCCESS";
export const ADD_WEEK_TEMPLATE_SHIFT_FAIL = "ADD_WEEK_TEMPLATE_SHIFT_FAIL";

//ADD_MANY_EMPLOYEES_WEEK_SHIFT
export const ADD_MANY_EMPLOYEES_WEEK_SHIFT_REQUEST =
  "ADD_MANY_EMPLOYEES_WEEK_SHIFT_REQUEST";
export const ADD_MANY_EMPLOYEES_WEEK_SHIFT_SUCCESS =
  "ADD_MANY_EMPLOYEES_WEEK_SHIFT_SUCCESS";
export const ADD_MANY_EMPLOYEES_WEEK_SHIFT_FAIL =
  "ADD_MANY_EMPLOYEES_WEEK_SHIFT_FAIL";

//DELETE_MANY_EMPLOYEES_WEEK_SHIFT
export const DELETE_MANY_EMPLOYEES_WEEK_SHIFT_REQUEST =
  "DELETE_MANY_EMPLOYEES_WEEK_SHIFT_REQUEST";
export const DELETE_MANY_EMPLOYEES_WEEK_SHIFT_SUCCESS =
  "DELETE_MANY_EMPLOYEES_WEEK_SHIFT_SUCCESS";
export const DELETE_MANY_EMPLOYEES_WEEK_SHIFT_FAIL =
  "DELETE_MANY_EMPLOYEES_WEEK_SHIFT_FAIL";

//GET_SHIFT
export const GET_SHIFT_REQUEST = "GET_SHIFT_REQUEST";
export const GET_SHIFT_SUCCESS = "GET_SHIFT_SUCCESS";
export const GET_SHIFT_FAIL = "GET_SHIFT_FAIL";

//GET_EMP_FILTER_API
export const GET_EMP_FILTER_REQUEST = "GET_EMP_FILTER_REQUEST";
export const GET_EMP_FILTER_SUCCESS = "GET_EMP_FILTER_SUCCESS";
export const GET_EMP_FILTER_FAIL = "GET_EMP_FILTER_FAIL";

//DOWNLOAD_CSV_XLSX_PDF
export const DOWNLOAD_SHIFTS_REQUEST = "DOWNLOAD_SHIFTS_REQUEST";
export const DOWNLOAD_SHIFTS_SUCCESS = "DOWNLOAD_SHIFTS_SUCCESS";
export const DOWNLOAD_SHIFTS_FAIL = "DOWNLOAD_SHIFTS_FAIL";

//GET_SHIFT_MANAGEMENT
export const GET_SHIFT_MANAGEMENT_REQUEST = "GET_SHIFT_MANAGEMENT_REQUEST";
export const GET_SHIFT_MANAGEMENT_SUCCESS = "GET_SHIFT_MANAGEMENT_SUCCESS";
export const GET_SHIFT_MANAGEMENT_FAIL = "GET_SHIFT_MANAGEMENT_FAIL";

//UPDATE_STATUS_SHIFT
export const UPDATE_STATUS_SHIFT_REQUEST = "UPDATE_STATUS_SHIFT_REQUEST";
export const UPDATE_STATUS_SHIFT_SUCCESS = "UPDATE_STATUS_SHIFT_SUCCESS";
export const UPDATE_STATUS_SHIFT_FAIL = "UPDATE_STATUS_SHIFT_FAIL";

//ADD_USER_ID_SHIFT
export const ADD_USER_ID_SHIFT_REQUEST = "ADD_USER_ID_SHIFT_REQUEST";
export const ADD_USER_ID_SHIFT_SUCCESS = "ADD_USER_ID_SHIFT_SUCCESS";
export const ADD_USER_ID_SHIFT_FAIL = "ADD_USER_ID_SHIFT_FAIL";

//ADD_BULK_SHIFT
export const ADD_BULK_SHIFT_REQUEST = "ADD_BULK_SHIFT_REQUEST";
export const ADD_BULK_SHIFT_SUCCESS = "ADD_BULK_SHIFT_SUCCESS";
export const ADD_BULK_SHIFT_FAIL = "ADD_BULK_SHIFT_FAIL";

//ADD_MANY_USER_ID_IN_SHIFT
export const ADD_MANY_USER_ID_IN_SHIFT_REQUEST =
  "ADD_MANY_USER_ID_IN_SHIFT_REQUEST";
export const ADD_MANY_USER_ID_IN_SHIFT_SUCCESS =
  "ADD_MANY_USER_ID_IN_SHIFT_SUCCESS";
export const ADD_MANY_USER_ID_IN_SHIFT_FAIL = "ADD_MANY_USER_ID_IN_SHIFT_FAIL";

//UPDATE_STATUS_OF_SHIFT
export const UPDATE_STATUS_OF_SHIFT_REQUEST = "UPDATE_STATUS_OF_SHIFT_REQUEST";
export const UPDATE_STATUS_OF_SHIFT_SUCCESS = "UPDATE_STATUS_OF_SHIFT_SUCCESS";
export const UPDATE_STATUS_OF_SHIFT_FAIL = "UPDATE_STATUS_OF_SHIFT_FAIL";

//CHANGE_STATUS_OF_TEMPLATE_SHIFT
export const CHANGE_STATUS_OF_TEMPLATE_SHIFT_REQUEST =
  "CHANGE_STATUS_OF_TEMPLATE_SHIFT_REQUEST";
export const CHANGE_STATUS_OF_TEMPLATE_SHIFT_SUCCESS =
  "CHANGE_STATUS_OF_TEMPLATE_SHIFT_SUCCESS";
export const CHANGE_STATUS_OF_TEMPLATE_SHIFT_FAIL =
  "CHANGE_STATUS_OF_TEMPLATE_SHIFT_FAIL";

//REMOVE_MANY_USER_ID_IN_SHIFT
export const REMOVE_MANY_USER_ID_IN_SHIFT_REQUEST =
  "REMOVE_MANY_USER_ID_IN_SHIFT_REQUEST";
export const REMOVE_MANY_USER_ID_IN_SHIFT_SUCCESS =
  "REMOVE_MANY_USER_ID_IN_SHIFT_SUCCESS";
export const REMOVE_MANY_USER_ID_IN_SHIFT_FAIL =
  "REMOVE_MANY_USER_ID_IN_SHIFT_FAIL";

//ADD_USER_DEPARTMENT_IMPORT
export const ADMIN_ADD_USER_DEPARTMENT_IMPORT_REQUEST =
  "ADMIN_ADD_USER_DEPARTMENT_IMPORT_REQUEST";
export const ADMIN_ADD_USER_DEPARTMENT_IMPORT_SUCCESS =
  "ADMIN_ADD_USER_DEPARTMENT_IMPORT_SUCCESS";
export const ADMIN_ADD_USER_DEPARTMENT_IMPORT_FAIL =
  "ADMIN_ADD_USER_DEPARTMENT_IMPORT_FAIL";

//CHECK_USER_DEPARTMENT_IMPORT
export const ADMIN_CHECK_USER_DEPARTMENT_IMPORT_REQUEST =
  "ADMIN_CHECK_USER_DEPARTMENT_IMPORT_REQUEST";
export const ADMIN_CHECK_USER_DEPARTMENT_IMPORT_SUCCESS =
  "ADMIN_CHECK_USER_DEPARTMENT_IMPORT_SUCCESS";
export const ADMIN_CHECK_USER_DEPARTMENT_IMPORT_FAIL =
  "ADMIN_CHECK_USER_DEPARTMENT_IMPORT_FAIL";

//ADD_USER_LEAVEDAYS_IMPORT
export const ADMIN_ADD_USER_LEAVEDAYS_IMPORT_REQUEST =
  "ADMIN_ADD_USER_LEAVEDAYS_IMPORT_REQUEST";
export const ADMIN_ADD_USER_LEAVEDAYS_IMPORT_SUCCESS =
  "ADMIN_ADD_USER_LEAVEDAYS_IMPORT_SUCCESS";
export const ADMIN_ADD_USER_LEAVEDAYS_IMPORT_FAIL =
  "ADMIN_ADD_USER_LEAVEDAYS_IMPORT_FAIL";

//CHECK_USER_LEAVEDAYS_IMPORT
export const ADMIN_CHECK_USER_LEAVEDAYS_IMPORT_REQUEST =
  "ADMIN_CHECK_USER_LEAVEDAYS_IMPORT_REQUEST";
export const ADMIN_CHECK_USER_LEAVEDAYS_IMPORT_SUCCESS =
  "ADMIN_CHECK_USER_LEAVEDAYS_IMPORT_SUCCESS";
export const ADMIN_CHECK_USER_LEAVEDAYS_IMPORT_FAIL =
  "ADMIN_CHECK_USER_LEAVEDAYS_IMPORT_FAIL";

//ADD_USER_LEAVES_IMPORT
export const ADMIN_ADD_USER_LEAVES_IMPORT_REQUEST =
  "ADMIN_ADD_USER_LEAVES_IMPORT_REQUEST";
export const ADMIN_ADD_USER_LEAVES_IMPORT_SUCCESS =
  "ADMIN_ADD_USER_LEAVES_IMPORT_SUCCESS";
export const ADMIN_ADD_USER_LEAVES_IMPORT_FAIL =
  "ADMIN_ADD_USER_LEAVES_IMPORT_FAIL";

//CHECK_USER_LEAVES_IMPORT
export const ADMIN_CHECK_USER_LEAVES_IMPORT_REQUEST =
  "ADMIN_CHECK_USER_LEAVES_IMPORT_REQUEST";
export const ADMIN_CHECK_USER_LEAVES_IMPORT_SUCCESS =
  "ADMIN_CHECK_USER_LEAVES_IMPORT_SUCCESS";
export const ADMIN_CHECK_USER_LEAVES_IMPORT_FAIL =
  "ADMIN_CHECK_USER_LEAVES_IMPORT_FAIL";

//ADD_USER_CHECKINOUT_IMPORT
export const ADMIN_ADD_USER_CHECKINOUT_IMPORT_REQUEST =
  "ADMIN_ADD_USER_CHECKINOUT_IMPORT_REQUEST";
export const ADMIN_ADD_USER_CHECKINOUT_IMPORT_SUCCESS =
  "ADMIN_ADD_USER_CHECKINOUT_IMPORT_SUCCESS";
export const ADMIN_ADD_USER_CHECKINOUT_IMPORT_FAIL =
  "ADMIN_ADD_USER_CHECKINOUT_IMPORT_FAIL";

//CHECK_USER_CHECKINOUT_IMPORT
export const ADMIN_CHECK_USER_CHECKINOUT_IMPORT_REQUEST =
  "ADMIN_CHECK_USER_CHECKINOUT_IMPORT_REQUEST";
export const ADMIN_CHECK_USER_CHECKINOUT_IMPORT_SUCCESS =
  "ADMIN_CHECK_USER_CHECKINOUT_IMPORT_SUCCESS";
export const ADMIN_CHECK_USER_CHECKINOUT_IMPORT_FAIL =
  "ADMIN_CHECK_USER_CHECKINOUT_IMPORT_FAIL";
//GET_WORK_BREAK
export const GET_WORK_BREAK_REQUEST = "GET_WORK_BREAK_REQUEST";
export const GET_WORK_BREAK_SUCCESS = "GET_WORK_BREAK_SUCCESS";
export const GET_WORK_BREAK_FAIL = "GET_WORK_BREAK_FAIL";

//ADD_WORK_BREAK
export const ADD_WORK_BREAK_REQUEST = "ADD_WORK_BREAK_REQUEST";
export const ADD_WORK_BREAK_SUCCESS = "ADD_WORK_BREAK_SUCCESS";
export const ADD_WORK_BREAK_FAIL = "ADD_WORK_BREAK_FAIL";

//ADD_USER_IN_WORK_BREAK
export const ADD_USER_IN_WORK_BREAK_REQUEST = "ADD_USER_IN_WORK_BREAK_REQUEST";
export const ADD_USER_IN_WORK_BREAK_SUCCESS = "ADD_USER_IN_WORK_BREAK_SUCCESS";
export const ADD_USER_IN_WORK_BREAK_FAIL = "ADD_USER_IN_WORK_BREAK_FAIL";

//REMOVE_USER_IN_WORK_BREAK
export const REMOVE_USER_IN_WORK_BREAK_REQUEST =
  "REMOVE_USER_IN_WORK_BREAK_REQUEST";
export const REMOVE_USER_IN_WORK_BREAK_SUCCESS =
  "REMOVE_USER_IN_WORK_BREAK_SUCCESS";
export const REMOVE_USER_IN_WORK_BREAK_FAIL = "REMOVE_USER_IN_WORK_BREAK_FAIL";

//ADD_USER_CHECKIN
export const ADD_USER_CHECKIN_REQUEST = "ADD_USER_CHECKIN_REQUEST";
export const ADD_USER_CHECKIN_SUCCESS = "ADD_USER_CHECKIN_SUCCESS";
export const ADD_USER_CHECKIN_FAIL = "ADD_USER_CHECKIN_FAIL";

//DELETE_USER_CHECKIN
export const DELETE_USER_CHECKIN_REQUEST = "DELETE_USER_CHECKIN_REQUEST";
export const DELETE_USER_CHECKIN_SUCCESS = "DELETE_USER_CHECKIN_SUCCESS";
export const DELETE_USER_CHECKIN_FAIL = "DELETE_USER_CHECKIN_FAIL";

//GET_SEVEN_DAYS_USER_CHECKIN
export const GET_SEVEN_DAYS_USER_CHECKIN_REQUEST =
  "GET_SEVEN_DAYS_USER_CHECKIN_REQUEST";
export const GET_SEVEN_DAYS_USER_CHECKIN_SUCCESS =
  "GET_SEVEN_DAYS_USER_CHECKIN_SUCCESS";
export const GET_SEVEN_DAYS_USER_CHECKIN_FAIL =
  "GET_SEVEN_DAYS_USER_CHECKIN_FAIL";

//GET_ALL_USER_DOCS
export const GET_ALL_USER_DOCS_REQUEST = "GET_ALL_USER_DOCS_REQUEST";
export const GET_ALL_USER_DOCS_SUCCESS = "GET_ALL_USER_DOCS_SUCCESS";
export const GET_ALL_USER_DOCS_FAIL = "GET_ALL_USER_DOCS_FAIL";

//EMPLOYEE_SALARY_CSV
export const EMPLOYEE_SALARY_CSV_REQUEST = "EMPLOYEE_SALARY_CSV_REQUEST";
export const EMPLOYEE_SALARY_CSV_SUCCESS = "EMPLOYEE_SALARY_CSV_SUCCESS";
export const EMPLOYEE_SALARY_CSV_FAIL = "EMPLOYEE_SALARY_CSV_FAIL";

//ADD_NEW_EMPLOYEE
export const ADD_NEW_EMPLOYEE_REQUEST = "ADD_NEW_EMPLOYEE_REQUEST";
export const ADD_NEW_EMPLOYEE_SUCCESS = "ADD_NEW_EMPLOYEE_SUCCESS";
export const ADD_NEW_EMPLOYEE_FAIL = "ADD_NEW_EMPLOYEE_FAIL";

//UPDATE_USER_DOCUMENT
export const UPDATE_USER_DOCUMENT_REQUEST = "UPDATE_USER_DOCUMENT_REQUEST";
export const UPDATE_USER_DOCUMENT_SUCCESS = "UPDATE_USER_DOCUMENT_SUCCESS";
export const UPDATE_USER_DOCUMENT_FAIL = "UPDATE_USER_DOCUMENT_FAIL";

//UPDATE_CHANGE_USER_DOCUMENT
export const UPDATE_CHANGE_USER_DOCUMENT_REQUEST =
  "UPDATE_CHANGE_USER_DOCUMENT_REQUEST";
export const UPDATE_CHANGE_USER_DOCUMENT_SUCCESS =
  "UPDATE_CHANGE_USER_DOCUMENT_SUCCESS";
export const UPDATE_CHANGE_USER_DOCUMENT_FAIL =
  "UPDATE_CHANGE_USER_DOCUMENT_FAIL";

//CREATE_USER_DOCUMENT
export const CREATE_USER_DOCUMENT_REQUEST = "CREATE_USER_DOCUMENT_REQUEST";
export const CREATE_USER_DOCUMENT_SUCCESS = "CREATE_USER_DOCUMENT_SUCCESS";
export const CREATE_USER_DOCUMENT_FAIL = "CREATE_USER_DOCUMENT_FAIL";

//UPLOAD_USER_DOCUMENT_FILE
export const UPLOAD_USER_DOCUMENT_FILE_REQUEST =
  "UPLOAD_USER_DOCUMENT_FILE_REQUEST";
export const UPLOAD_USER_DOCUMENT_FILE_SUCCESS =
  "UPLOAD_USER_DOCUMENT_FILE_SUCCESS";
export const UPLOAD_USER_DOCUMENT_FILE_FAIL = "UPLOAD_USER_DOCUMENT_FILE_FAIL";

//GET_ALL_USER_DYNAMIC_DOCUMENTS
export const GET_ALL_USER_DYNAMIC_DOCUMENTS_REQUEST =
  "GET_ALL_USER_DYNAMIC_DOCUMENTS_REQUEST";
export const GET_ALL_USER_DYNAMIC_DOCUMENTS_SUCCESS =
  "GET_ALL_USER_DYNAMIC_DOCUMENTS_SUCCESS";
export const GET_ALL_USER_DYNAMIC_DOCUMENTS_FAIL =
  "GET_ALL_USER_DYNAMIC_DOCUMENTS_FAIL";

//GET_COMPANY_HIERARCHY
export const GET_COMPANY_HIERARCHY_REQUEST = "GET_COMPANY_HIERARCHY_REQUEST";
export const GET_COMPANY_HIERARCHY_SUCCESS = "GET_COMPANY_HIERARCHY_SUCCESS";
export const GET_COMPANY_HIERARCHY_FAIL = "GET_COMPANY_HIERARCHY_FAIL";
//GET_DEPARTMENT_HIERARCHY
export const GET_DEPARTMENT_HIERARCHY_REQUEST =
  "GET_DEPARTMENT_HIERARCHY_REQUEST";
export const GET_DEPARTMENT_HIERARCHY_SUCCESS =
  "GET_DEPARTMENT_HIERARCHY_SUCCESS";
export const GET_DEPARTMENT_HIERARCHY_FAIL = "GET_DEPARTMENT_HIERARCHY_FAIL";

//CHANGE_COMPANY_HIERARCHY
export const CHANGE_COMPANY_HIERARCHY_REQUEST =
  "CHANGE_COMPANY_HIERARCHY_REQUEST";
export const CHANGE_COMPANY_HIERARCHY_SUCCESS =
  "CHANGE_COMPANY_HIERARCHY_SUCCESS";
export const CHANGE_COMPANY_HIERARCHY_FAIL = "CHANGE_COMPANY_HIERARCHY_FAIL";

//EMPLOYEE_ADD_STEPPER_LEAVE_REQUEST
export const EMPLOYEE_ADD_STEPPER_LEAVE_REQUEST_REQUEST =
  "EMPLOYEE_ADD_STEPPER_LEAVE_REQUEST_REQUEST";
export const EMPLOYEE_ADD_STEPPER_LEAVE_REQUEST_SUCCESS =
  "EMPLOYEE_ADD_STEPPER_LEAVE_REQUEST_SUCCESS";
export const EMPLOYEE_ADD_STEPPER_LEAVE_REQUEST_FAIL =
  "EMPLOYEE_ADD_STEPPER_LEAVE_REQUEST_FAIL";

  //GET_LEAVE_BY_USER
export const GET_LEAVE_BY_USER_REQUEST = "GET_LEAVE_BY_USER_REQUEST";
export const GET_LEAVE_BY_USER_SUCCESS = "GET_LEAVE_BY_USER_SUCCESS"; 
export const GET_LEAVE_BY_USER_FAIL = "GET_LEAVE_BY_USER_FAIL";